module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp12_9005.247afe0d.png";